import { useState } from 'react';

export function useFileHubCache() {
  const [clientsCache, setClientsCache] = useState([]);
  const [clientsCacheLoading, setClientsCacheLoading] = useState(false);
  const [workspacesCache, setWorkspacesCache] = useState([]);
  const [workspacesCacheLoading, setWorkspacesCacheLoading] = useState(false);

  return {
    clientsCache, setClientsCache,
    clientsCacheLoading, setClientsCacheLoading,
    workspacesCache, setWorkspacesCache,
    workspacesCacheLoading, setWorkspacesCacheLoading,
  };
}
